<template>
  <div :class="$style.app" @click="onGlobalTap" @touchstart="onGlobalTap">
    <AppLoader v-if="$store.state.loading && !$store.state.bootCompleted" />

    <Header />
    <div :class="$style.container">
      <router-view v-slot="{ Component, route }">
        <transition name="page-fade" mode="out-in">
          <!-- Ключ = fullPath, КРОМЕ карточки товара: смена размера меняет
               /product/{id} — без общего ключа компонент пересоздавался бы
               (скелетон + потеря скролла = «прыжок наверх»). Для Product
               экземпляр переиспользуется, данные обновляет watch productId. -->
          <component
            :is="Component"
            :key="route.name === 'Product' ? 'Product' : route.fullPath"
          />
        </transition>
      </router-view>
    </div>
    <NavBar v-if="showNavBar" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue"
import NavBar from "@/components/NavBar.vue"
import AppLoader from "@/components/AppLoader.vue"

export default {
  components: { NavBar, Header, AppLoader },
  data() {
    return {
      backHandlerRef: null,
      customBackHandlers: [],
      ws: null,
      wsReconnectTimer: null,
      wsReconnectDisabled: false,
    }
  },
  computed: {
    isActivated() {
      return this.$store.state.user.is_activated
    },
    showNavBar() {
      return (
        this.isActivated &&
        !this.$store.state.filtersModalOpen &&
        !this.$store.state.sortModalOpen &&
        this.$route.name !== "PersonalInfo" &&
        this.$route.name !== "CheckEmail" &&
        this.$route.name !== "MyProducts" &&
        this.$route.name !== "AddedProduct" &&
        this.$route.name !== "EditProduct" &&
        this.$route.name !== "UploadExcel" &&
        this.$route.name !== "Product" &&
        this.$route.name !== "Bid" &&
        this.$route.name !== "SelectSize" &&
        this.$route.name !== "deal-feedback" &&
        this.$route.name !== "extend-delivery" &&
        this.$route.name !== "decline-reason" &&
        this.$route.name !== "cancel-reason" &&
        this.$route.name !== "propose-price" &&
        this.$route.name !== "SelectModel" &&
        this.$route.name !== "EditDeliveryTime" &&
        this.$route.name !== "DeliveryPicker"
      )
    },
    bootCompleted() {
      return this.$store.state.bootCompleted
    },
  },
  watch: {
    isActivated: {
      immediate: true,
      handler(newVal) {
        // Подключаем WS только для активированных пользователей
        if (newVal) {
          this.wsReconnectDisabled = false
          // Чтобы счетчик был сразу после перезагрузки на любой странице
          this.$store.dispatch("getProfile")
          this.connectWebSocket()
        } else {
          this.disconnectWebSocket()
          this.wsReconnectDisabled = false
        }
      },
    },
    bootCompleted(newVal) {
      // Когда загрузка завершена, убеждаемся что Header видим
      if (newVal) {
        this.$nextTick(() => {
          this.ensureHeaderVisible()
        })
        // Дополнительная проверка через небольшую задержку
        setTimeout(() => {
          this.ensureHeaderVisible()
        }, 100)
        setTimeout(() => {
          this.ensureHeaderVisible()
        }, 500)
      }
    },
    "$store.state.loading"(newVal) {
      // Когда загрузка завершается, проверяем Header
      if (!newVal && this.bootCompleted) {
        this.$nextTick(() => {
          this.ensureHeaderVisible()
        })
      }
    },
  },
  methods: {
    // Глобальное закрытие клавиатуры
    onGlobalTap(e) {
      const target = e.target
      const tag = target.tagName

      // если клик по полю ввода — не блЮрим
      if (tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable) {
        return
      }

      const active = document.activeElement
      if (
        active &&
        (active.tagName === "INPUT" ||
          active.tagName === "TEXTAREA" ||
          active.isContentEditable)
      ) {
        active.blur()
      }
    },
    pushCustomBackHandler(handler) {
      if (typeof handler !== "function") return
      this.customBackHandlers.push(handler)
    },
    popCustomBackHandler(handler) {
      if (!handler) {
        this.customBackHandlers.pop()
        return
      }
      const idx = this.customBackHandlers.lastIndexOf(handler)
      if (idx !== -1) {
        this.customBackHandlers.splice(idx, 1)
      }
    },
    handleCustomBack() {
      if (!this.customBackHandlers.length) return false
      const handler =
        this.customBackHandlers[this.customBackHandlers.length - 1]
      const result = handler()
      return result !== false
    },
    ensureHeaderVisible() {
      // Ищем Header по data-атрибуту
      const headerEl = document.querySelector('[data-header="true"]')
      if (headerEl) {
        // Принудительно восстанавливаем видимость
        headerEl.style.setProperty("display", "flex", "important")
        headerEl.style.setProperty("visibility", "visible", "important")
        headerEl.style.setProperty("opacity", "1", "important")
        headerEl.style.setProperty("position", "fixed", "important")
        headerEl.style.setProperty("z-index", "10000", "important")
      }
    },
    connectWebSocket() {
      const tg = window.Telegram?.WebApp
      if (!tg?.initData) {
        // не Telegram окружение — WS не подключаем
        return
      }

      // Если уже подключены, не подключаемся снова
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        return
      }

      // Закрываем старое соединение, если есть
      if (this.ws) {
        try {
          this.ws.close()
        } catch (e) {
          window.console.log(e)
        }
      }

      // Формируем URL для WebSocket (перенесено из Account.vue)
      const wsBaseUrl =
        process.env.WS_API_BASE_URL ||
        "wss://snkrroom-resell.ru/api/resell/v1/ws/notifications"
      const initData = encodeURIComponent(tg.initData)
      const wsUrl = `${wsBaseUrl}?init_data=${initData}`

      try {
        console.log(
          "Подключение к WebSocket в App:",
          wsUrl.replace(initData, "[REDACTED]")
        )
        this.ws = new WebSocket(wsUrl)

        this.ws.onopen = () => {
          console.log("WebSocket подключен для счетчика уведомлений")
        }

        this.ws.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data)

            // Формат ожидаем такой:
            // { "type": "notify_counter", "unread_count": 109 }
            if (data?.type === "notify_counter") {
              const nextCount = Number(data.unread_count)
              if (!Number.isNaN(nextCount)) {
                this.$store.commit("setNotificationsCount", nextCount)
              }
            }
          } catch (error) {
            console.error("Ошибка при обработке сообщения WebSocket:", error)
            console.error("Данные:", event.data)
          }
        }

        this.ws.onerror = (error) => {
          console.error("Ошибка WebSocket:", error)
          console.error("Состояние WebSocket:", this.ws?.readyState)
        }

        this.ws.onclose = (event) => {
          this.ws = null

          // Пытаемся переподключиться через 5 секунд, если это не было намеренное закрытие
          if (this.wsReconnectDisabled) return
          if (!this.isActivated) return

          if (event.code !== 1000) {
            if (this.wsReconnectTimer) {
              clearTimeout(this.wsReconnectTimer)
            }
            this.wsReconnectTimer = setTimeout(() => {
              this.connectWebSocket()
            }, 5000)
          }
        }
      } catch (error) {
        console.error("Ошибка при подключении WebSocket:", error)
        this.ws = null
      }
    },
    disconnectWebSocket() {
      this.wsReconnectDisabled = true
      if (this.wsReconnectTimer) {
        clearTimeout(this.wsReconnectTimer)
        this.wsReconnectTimer = null
      }
      if (this.ws) {
        try {
          // Закрываем с кодом 1000 (нормальное закрытие)
          this.ws.close(1000, "Component unmounting")
        } catch (e) {
          window.console.log(e)
        }
        this.ws = null
      }
    },
  },
  async mounted() {
    const tg = window.Telegram?.WebApp

    // Telegram WebApp initialization (only if available)
    if (tg) {
      tg.ready()
      tg.expand()

      try {
        tg.disableVerticalSwipes()
      } catch {
        // Not supported in older versions
      }

      try {
        if (tg.platform === "android" || tg.platform === "ios") {
          tg.requestFullscreen()
          // После requestFullscreen убеждаемся, что Header видим
          this.$nextTick(() => {
            setTimeout(() => {
              this.ensureHeaderVisible()
            }, 100)
          })
        } else {
          tg.exitFullscreen()
        }
      } catch {
        // Not supported in older versions
      }
    }

    // No Telegram WebApp: load user directly
    if (!tg?.initData) {
      await this.$store.dispatch("userMe")
      this.$store.commit("setBootCompleted", true)
      return
    }

    if (typeof tg.setBottomBarColor === "function") {
      tg.setBottomBarColor("#F2F2F2")
      tg.setHeaderColor("#F2F2F2")
      tg.setBackgroundColor("#ffffff")
      // После установки цветов проверяем Header
      this.$nextTick(() => {
        setTimeout(() => {
          this.ensureHeaderVisible()
        }, 50)
      })
    }

    const router = this.$router
    const BB = tg.BackButton

    const bindBack = (fn) => {
      if (!BB) return
      if (this.backHandlerRef) {
        try {
          BB.offClick(this.backHandlerRef)
        } catch (e) {
          window.console.log(e)
        }
        this.backHandlerRef = null
      }
      if (fn) {
        this.backHandlerRef = fn
        BB.onClick(fn)
      }
    }

    const updateBack = (to) => {
      if (!BB) return
      const mode = to?.meta?.tgBack || "history"
      if (mode === "disabled") {
        BB.hide()
        bindBack(null)
        return
      }
      if (mode === "custom" && typeof to.meta.tgBackHandler === "function") {
        BB.show()
        bindBack(() => {
          if (this.handleCustomBack()) return
          to.meta.tgBackHandler({ tg, router })
        })
        return
      }
      const hasBack = !!router.options.history.state.back
      if (hasBack) {
        BB.show()
        bindBack(() => {
          if (this.handleCustomBack()) return
          router.back()
        })
      } else {
        BB.hide()
        bindBack(null)
      }
    }

    this.unlisten = router.afterEach((to) => updateBack(to))
    updateBack(router.currentRoute.value)

    window.__AppBackHandlerStack = {
      push: (handler) => this.pushCustomBackHandler(handler),
      pop: (handler) => this.popCustomBackHandler(handler),
    }

    const disablePinch = (e) => e.preventDefault()
    const disableCtrlWheel = (e) => {
      if (e.ctrlKey) e.preventDefault()
    }
    document.addEventListener("gesturestart", disablePinch, { passive: false })
    document.addEventListener("gesturechange", disablePinch, {
      passive: false,
    })
    document.addEventListener("gestureend", disablePinch, { passive: false })
    window.addEventListener("wheel", disableCtrlWheel, { passive: false })
    this._zoomGuards = { disablePinch, disableCtrlWheel }

    const initPromise = await this.$store.dispatch("checkInitData", {
      _auth: tg.initData,
    })

    const userPromise = await this.$store.dispatch("userMe")

    await Promise.all([initPromise, userPromise])

    // if (this.$store.state.user.is_activated) {
    //   await this.$store.dispatch("getFavorites", {
    //     limit: 20,
    //     offset: 0,
    //   })

    //   // здесь будут оставльные запросы по типу мои товары и так далее
    // }

    setTimeout(() => {
      // После первичной загрузки больше не показываем фуллскрин AppLoader
      this.$store.commit("setBootCompleted", true)
      // Убеждаемся, что Header видим после загрузки
      this.$nextTick(() => {
        this.ensureHeaderVisible()
      })
      // Дополнительные проверки
      setTimeout(() => {
        this.ensureHeaderVisible()
      }, 50)
      setTimeout(() => {
        this.ensureHeaderVisible()
      }, 300)
    }, 200)

    // Проверка Header сразу после монтирования и регулярно
    this.$nextTick(() => {
      this.ensureHeaderVisible()
    })

    // Регулярная проверка видимости Header (защита от скрытия)
    this._headerCheckInterval = setInterval(() => {
      this.ensureHeaderVisible()
    }, 1000)

    // Обработчик изменения ориентации экрана
    const handleOrientationChange = () => {
      // Небольшая задержка для завершения поворота
      setTimeout(() => {
        this.ensureHeaderVisible()
        // Дополнительная проверка после поворота
        setTimeout(() => {
          this.ensureHeaderVisible()
        }, 300)
      }, 100)
    }

    window.addEventListener("orientationchange", handleOrientationChange)

    this._handleOrientationChange = handleOrientationChange
    this._orientationCleanup = () => {
      window.removeEventListener(
        "orientationchange",
        this._handleOrientationChange
      )
    }
  },
  beforeUnmount() {
    const tg = window.Telegram?.WebApp
    const BB = tg?.BackButton
    if (BB && this.backHandlerRef) {
      try {
        BB.offClick(this.backHandlerRef)
      } catch (e) {
        window.console.log(e)
      }
    }
    if (this.unlisten) this.unlisten()

    if (window.__AppBackHandlerStack) {
      delete window.__AppBackHandlerStack
    }

    if (!this._zoomGuards) return
    document.removeEventListener("gesturestart", this._zoomGuards.disablePinch)
    document.removeEventListener("gesturechange", this._zoomGuards.disablePinch)
    document.removeEventListener("gestureend", this._zoomGuards.disablePinch)
    window.removeEventListener("wheel", this._zoomGuards.disableCtrlWheel)

    // Очистка интервала проверки Header
    if (this._headerCheckInterval) {
      clearInterval(this._headerCheckInterval)
    }

    // Очистка обработчиков ориентации
    if (typeof this._orientationCleanup === "function") {
      this._orientationCleanup()
    }

    this.disconnectWebSocket()
  },
}
</script>

<style lang="scss" module>
@import "@/assets/scss/main.scss";

.app {
  min-height: 100vh;
  background: #ffffff;
}

.container {
  padding-top: var(--app-header-height, 72px);
}

.containerNoPadding {
  padding-top: 0;
}

:global(.page-fade-enter-active),
:global(.page-fade-leave-active) {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

:global(.page-fade-enter-from),
:global(.page-fade-leave-to) {
  opacity: 0;
  transform: translateY(10px);
}

:global(.page-fade-enter-to),
:global(.page-fade-leave-from) {
  opacity: 1;
  transform: translateY(0);
}
</style>
